import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Collapse } from '@mui/material';
import { routesName } from '../../constants/routes-name';
import { useSelector } from 'react-redux';
import useScreen from '../../hooks/useScreen';

function SideMenuNew({ isMenuOpen = false, setIsMenuOpen = () => {} }) {
  const { isMenuOverly } = useScreen();
  const { user, role } = useSelector(({ user }) => user);
  const forCards = 'opens-sub-menu-for-cards';
  const forTender = 'opens-sub-menu-for-tender';
  const forMessages = 'opens-sub-menu-for-message';
  const forBids = 'opens-sub-menu-for-bids';
  const location = useLocation();
  const [isSubMenuOpen, setIsSubMenuOpen] = useState('');

  const openSubMenueFor = () => {
    if (
      location.pathname === routesName.cardsListing ||
      location.pathname === routesName.templates
    ) {
      setIsSubMenuOpen(forCards);
    } else if (
      location.pathname === routesName.tenderListing ||
      location.pathname === routesName.myTenderListing ||
      location.pathname === routesName.supplierAllTenderListing
    ) {
      setIsSubMenuOpen(forTender);
    } else if (
      location.pathname === routesName.draftBids ||
      location.pathname === routesName.submittedBids ||
      location.pathname === routesName.closedBids
    ) {
      setIsSubMenuOpen(forBids);
    } else if (location.pathname === routesName.unreadMessages) {
      setIsSubMenuOpen(forMessages);
    }
  };

  useEffect(() => {
    openSubMenueFor();
  }, []);

  const handleSubMenuToggleClick = (openFor = '') => {
    setIsSubMenuOpen(isSubMenuOpen === openFor ? '' : openFor);
  };

  const handleToggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div
      style={{
        userSelect: 'none',
        zIndex: 9999,
        backgroundColor: isMenuOverly ? 'white' : 'inherit',
      }}
      className="relative"
    >
      <Collapse
        sx={{
          '& .MuiCollapse-wrapperInner': {
            flex: 1,
          },
        }}
        orientation="horizontal"
        in={isMenuOpen}
        collapsedSize={0}
      >
        <div
          className="border overflow-y-auto"
          style={{ width: isMenuOverly ? '220px' : 'inherit' }}
        >
          <div className="flex flex-col overflow-y-auto text-sm">
            <Link
              onClick={handleSubMenuToggleClick}
              className={`p-3 border-b text-nowrap ${
                location.pathname === routesName.dashboard
                  ? 'text-[var(--blue)] bg-gray-50'
                  : ''
              }`}
              to={routesName.dashboard}
            >
              <span>Dashboard</span>
            </Link>

            <Link
              className={`p-3 border-b text-nowrap ${
                location.pathname === routesName.myTenderListing
                  ? 'text-[var(--blue)] bg-gray-50'
                  : ''
              }`}
              to={routesName.myTenderListing}
            >
              <span>My Tenders</span>
            </Link>

            <Link
              className={`p-3 border-b text-nowrap ${
                location.pathname === routesName.tenderListing
                  ? 'text-[var(--blue)] bg-gray-50'
                  : ''
              }`}
              to={routesName.tenderListing}
            >
              <span>All Tenders</span>
            </Link>

            <Link
              onClick={handleSubMenuToggleClick}
              className={`p-3 border-b text-nowrap ${
                location.pathname === routesName.chats
                  ? 'text-[var(--blue)] bg-gray-50'
                  : ''
              }`}
              to={routesName.chats}
            >
              <span>Messages</span>
            </Link>

            <Link
              className={`p-3 border-b-0 text-nowrap`}
              onClick={() => {
                localStorage.clear();
                window.location.reload();
              }}
              to={routesName.home}
            >
              <span>Logout</span>
            </Link>
          </div>
        </div>
      </Collapse>
      {isMenuOverly && (
        <span
          onClick={handleToggleMenu}
          className="rounded-full p-1 text-white bg-main absolute top-[50%] left-[92%] cursor-pointer"
        >
          {isMenuOpen ? (
            <ChevronLeft fontSize="large" />
          ) : (
            <ChevronRight fontSize="large" />
          )}
        </span>
      )}
    </div>
  );
}

export default SideMenuNew;
